/* load all the api method handlers */
import {
  setNodeProperty,
  setNodeProperties,
  getNodeSummaryProperties,
  getNodeProperties
} from "./handlers/Properties";
import {
  createImgNode,
  createTextNode,
  copySelectedNode,
  pasteSnippet,
  deleteNode,
  deleteSelection,
  arrangeSelection,
  groupSelection,
  unGroup,
  copy,
  paste
} from "./handlers/Nodes";
import { selectTool } from "./handlers/Tools";
import {
  load,
  save,
  setDocumentSize,
  getDocumentSize,
  getScale,
  getDocumentProperties,
  undo,
  redo,
  zoom
} from "./handlers/Document";
import { setConfig } from "./handlers/Config";
import ReactGA from "react-ga";

const gaEvent = event => {
  ReactGA.event({
    category: "Zwibbler Function Call",
    action: event
  });
};

/* export them as an object to add to the external api */
export default zwibbler => {
  return {
    setConfig: options => {
      gaEvent("setConfig");
      return setConfig(zwibbler, options);
    },
    selectTool: options => {
      gaEvent("selectTool." + options.tool);
      return selectTool(zwibbler, options);
    },

    //nodes and properties
    setNodeProperty: options => {
      gaEvent("setNodeProperty");
      return setNodeProperty(zwibbler, options);
    },
    setNodeProperties: options => {
      gaEvent("setNodeProperties");
      return setNodeProperties(zwibbler, options);
    },

    getNodeSummaryProperties: nodes => {
      gaEvent("getNodeSummaryProperties");
      return getNodeSummaryProperties(zwibbler, nodes);
    },
    getNodeProperties: params => {
      gaEvent("getNodeProperties");
      return getNodeProperties(zwibbler, params.nodes, params.properties);
    },

    createTextNode: config => {
      gaEvent("createTextNode");
      return createTextNode(zwibbler, config);
    },
    createImgNode: options => {
      gaEvent("createImgNode");
      return createImgNode(zwibbler, options);
    },
    copySelectedNode: () => {
      gaEvent("copySelectedNode");
      return copySelectedNode(zwibbler);
    },
    copy: () => {
      gaEvent("copy");
      return copy(zwibbler);
    },
    paste: () => {
      gaEvent("paste");
      return paste(zwibbler);
    },
    pasteSnippet: snippet => {
      gaEvent("pasteSnippet");
      return pasteSnippet(zwibbler, snippet);
    },
    deleteSelection: () => {
      gaEvent("deleteNodes");
      return deleteSelection(zwibbler, zwibbler);
    },
    deleteNodes: nodes => {
      gaEvent("getNodeProperties");
      return deleteNode(zwibbler, nodes);
    },
    arrangeSelection: command => {
      gaEvent("arrangeSelection");
      return arrangeSelection(zwibbler, command);
    },
    groupSelection: () => {
      gaEvent("groupSelection");
      return groupSelection(zwibbler);
    },
    unGroup: () => {
      gaEvent("unGroup");
      return unGroup(zwibbler);
    },

    // Document
    save: options => {
      gaEvent("save");
      return save(zwibbler, options);
    },
    loadDoc: document => {
      gaEvent("loadDoc");
      return load(zwibbler, document);
    },
    setDocumentSize: options => {
      gaEvent("setDocumentSize");
      return setDocumentSize(zwibbler, options);
    },
    getDocumentSize: options => {
      gaEvent("getDocumentSize");
      return getDocumentSize(zwibbler, options);
    },
    getScale: nodes => {
      gaEvent("getScale");
      return getScale(zwibbler);
    },
    getDocumentProperties: () => {
      gaEvent("getDocumentProperties");
      return getDocumentProperties(zwibbler);
    },
    undo: () => {
      gaEvent("undo");
      return undo(zwibbler);
    },
    redo: () => {
      gaEvent("redo");
      return redo(zwibbler);
    },
    zoom: inOrOut => {
      gaEvent("zoom");
      return zoom(zwibbler, inOrOut);
    }
  };
};



// WEBPACK FOOTER //
// ./src/components/Zwibbler/ExternalApi/index.js